
export class CfCoreGalleryImageSize {
    static Cover = 'cover';
    static Contain = 'contain';
}

function CfCoreGalleryImageSize_tsickle_Closure_declarations() {
/** @type {?} */
CfCoreGalleryImageSize.Cover;
/** @type {?} */
CfCoreGalleryImageSize.Contain;
}

